import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=fac355c8&scoped=true&"
import script from "./Download.vue?vue&type=script&lang=js&"
export * from "./Download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac355c8",
  null
  
)

export default component.exports